import React from 'react';
import styled from 'styled-components';
import EsItemBefore from './EsItemBefore';
import EsItemNone from './EsItemNone';
import { Log } from '../../lib/util/CustomUtil';


const EsItemBeforeListBlock = styled.div`

`;

const EsItemBeforeList = ({ esItems, loading, accessToken, curIdx, delStatus, handlleBeforeCheckClick, handleDeleteBeforeItem }) => {


    if (loading || esItems === undefined) {
        return <EsItemBeforeListBlock />
    }

    // 비로그인 상태이거나 견적서가 없을 때 표시 
    if (accessToken === null || esItems === null || esItems.length === 0) {
        //return <EsItemNone curIdx={curIdx} />
        return <EsItemBeforeListBlock />

    } else {

       // console.log("esItems = " + JSON.stringify(esItems))
        /*  로딩 중 아니고, 견적 리스트 배열이 존재할 때만 보여줌 */
        return (
            <EsItemBeforeListBlock>
                {
                    esItems.map((item, idx) => (
                        <EsItemBefore esItem={item} key={idx} delStatus={delStatus} handlleBeforeCheckClick={handlleBeforeCheckClick} handleDeleteBeforeItem={handleDeleteBeforeItem}/>
                    ))
                }
            </EsItemBeforeListBlock>
        );
    }



};

export default EsItemBeforeList;